<template>
  <div>
    <TagSelector mainHeading="" optionName="users" availableOptionsHeading="All Volunteers"
      selectedOptionsHeading="Persons with skill" :initial-skills="availableActivities"
      v-model:interests="userActivities" :onSave="readOnly ? null : handleSaveActivities" :loading="loading" :isSaving="submitting" />
  </div>
</template>

<script setup>
import { onMounted, ref, computed, watch } from "vue";
import { useStore } from "vuex";
import TagSelector from "@/components/common/TagSelector.vue";
import { useRoute } from "vue-router";
import { useToast } from "vue-toast-notification";

const props = defineProps({
    skillId: {
        type: [Number, String],
        default: null,
    },
    locationId: {
        type: [Number, String],
        default: null,
    },
    readOnly: {
        type: Boolean,
        default: false,
    },
});

const store = useStore();
const route = useRoute();
const toast = useToast();
const loading = ref(false);
const submitting = ref(false);

// ✅ Use props if provided, otherwise fallback to route params
const locationId = computed(() => {
    return props.locationId !== null ? Number(props.locationId) : Number(route.params.locationId);
});

const skillId = computed(() => {
    return props.skillId !== null ? Number(props.skillId) : Number(route.params.skillid);
});

// ✅ Reactive state
const availableActivities = ref([]); // all volunteers
const userActivities = ref([]); // persons with this skill

// ✅ Load volunteers for this skill
const loadSkillPersons = async () => {
  if (!skillId.value) return;
  
  loading.value = true;
  try {
    const { personsWithSkill, allVolunteers } = await store.dispatch("getSkillPersons", {
      skillId: skillId.value,
      locationId: locationId.value,
    });

    // ✅ Map data for TagSelector
    availableActivities.value = (allVolunteers || []).map((v) => ({
      id: v.personid,
      name: `${v.firstname} ${v.lastname}`,
      description: v.email || "",
    }));

    userActivities.value = (personsWithSkill || []).map((v) => ({
      id: v.personid,
      name: `${v.firstname} ${v.lastname}`,
      description: v.email || "",
    }));
  } catch (error) {
    console.error("Failed to load skill persons:", error);
    toast.error("Failed to load volunteers for this skill");
  } finally {
    loading.value = false;
  }
};

// ✅ Save handler for volunteers
const handleSaveActivities = async (selected) => {
  submitting.value = true;
  try {
    const userIds = selected.map((x) => x.id);

    const result = await store.dispatch("saveSkillPersons", {
      skillId: skillId.value,
      locationId: locationId.value,
      userIds,
    });

    // toast.success(result.message, { position: "top-right" });

    if (result.success) {
      await loadSkillPersons();
    }                                                     
    //   } else {
    //     toast.error(result.message || "Failed to update volunteers");
    //   }
    // } catch (error) {
    //   console.error("Failed to save volunteers:", error);
    //   toast.error("Failed to save volunteers for this skill");
  }
  finally {
    submitting.value = false;
  }
};

onMounted(async () => {
  await loadSkillPersons();
});

// Watch for skillId changes and reload data
watch(() => skillId.value, () => {
  loadSkillPersons();
});
</script>